import {ReactComponent as fifty_fifty} from "assets/img/trivia/rounds/50_50.svg";
import {ReactComponent as all_type_no_hype} from "assets/img/trivia/rounds/all_type_no_hype.svg";
import {ReactComponent as balls_and_bats} from "assets/img/trivia/rounds/balls_and_bats.svg";
import {ReactComponent as blazin_round} from "assets/img/trivia/rounds/blazin_round.svg";
import {ReactComponent as body_shots} from "assets/img/trivia/rounds/body_shots.svg";
import {ReactComponent as business_casual} from "assets/img/trivia/rounds/business_casual.svg";
import {ReactComponent as campari_wild_turkey_longbranch} from "assets/img/trivia/rounds/campari_wild_turkey_longbranch.svg";
import {ReactComponent as console_me} from "assets/img/trivia/rounds/console_me.svg";
import {ReactComponent as dos_equis} from "assets/img/trivia/rounds/dos_equis_small_logo.svg";
import {ReactComponent as finals} from "assets/img/trivia/rounds/finals.svg";
import {ReactComponent as geography_ugh} from "assets/img/trivia/rounds/geography_ugh.svg";
import {ReactComponent as heart_the_90s} from "assets/img/trivia/rounds/heart_the_90s.svg";
import {ReactComponent as heineken} from "assets/img/trivia/rounds/heineken.svg";
import {ReactComponent as history_lesson} from "assets/img/trivia/rounds/history_lesson.svg";
import {ReactComponent as icymi} from "assets/img/trivia/rounds/icymi.svg";
import {ReactComponent as in_telly_gent} from "assets/img/trivia/rounds/in_telly_gent.svg";
import {ReactComponent as just_trivia} from "assets/img/trivia/rounds/just_trivia.svg";
import {ReactComponent as light_sky} from "assets/img/trivia/rounds/LightSkyLogoSmall.svg";
import {ReactComponent as michelob_ultra} from "assets/img/trivia/rounds/michelob_ultra.svg";
import {ReactComponent as mother_earth} from "assets/img/trivia/rounds/mother_earth.svg";
// import { ReactComponent as dulce_vida_milestone } from "assets/img/trivia/rounds/dulce_vida_milestone";
import {ReactComponent as movie_buff} from "assets/img/trivia/rounds/movie_buff.svg";
import {ReactComponent as munchies} from "assets/img/trivia/rounds/munchies.svg";
import {ReactComponent as noted} from "assets/img/trivia/rounds/noted.svg";
import {ReactComponent as omg} from "assets/img/trivia/rounds/omg.svg";
import {ReactComponent as real_news} from "assets/img/trivia/rounds/real_news.svg";
import {ReactComponent as remember_books} from "assets/img/trivia/rounds/remember_books.svg";
import {ReactComponent as smarty_pants} from "assets/img/trivia/rounds/smarty_pants.svg";
import {ReactComponent as swipe_it} from "assets/img/trivia/rounds/swipe_it.svg";
import {ReactComponent as take_5} from "assets/img/trivia/rounds/take_5.svg";
import {ReactComponent as true_or_fail} from "assets/img/trivia/rounds/true_or_fail.svg";
import {ReactComponent as two_rights_and_wrong} from "assets/img/trivia/rounds/two_rights_and_wrong.svg";
import {ReactComponent as warm_ups} from "assets/img/trivia/rounds/warm_ups.svg";
import {ReactComponent as what_the_tech} from "assets/img/trivia/rounds/what_the_tech.svg";
import {ReactComponent as goat} from "assets/img/trivia/rounds/goat.svg";
import {map, random} from "lodash";
import {ITriviaContest} from "modules/reducers/contests_trivia";
import {IAnswerChoice, ITriviaCorrectAnswer, ITriviaQuestion} from "modules/reducers/trivia";
import {IS_TRIVIA_APP} from "modules/utils/constants";
import {toISO} from "modules/utils/date";
import {getParsedQS} from "modules/utils/dom";

import {
	EnumTriviaAnswerType,
	EnumTriviaContestStatus,
	EnumTriviaContestType,
	EnumTriviaStatusType
} from "modules/utils/enums";

import TagManager from 'react-gtm-module';

const ONE_SEC = 1000;
const ONE_MIN = 60 * ONE_SEC;

export const TIMINGS = {
	ONE_MIN,
	time_to_switch_on_before_screens: 30 * ONE_MIN,
	warning: 10 * ONE_SEC + 999,
	end_game_delay: 7 * ONE_MIN,
	long_round_break_3: 3 * ONE_MIN,
	long_round_break_5: 5 * ONE_MIN,
	set_user_as_playing_before: 15 * ONE_MIN,
	time_to_update_playing_users_scheduled: 2 * ONE_MIN,
	time_to_update_playing_users_live: ONE_MIN,
	swipe_it_results: 20 * ONE_SEC,
	swipe_it_bonus_points: 10 * ONE_SEC,
	spread_request_time: IS_TRIVIA_APP ? random(0, 2000) : random(0, ONE_SEC),
	pregame_countdown_time_shift: 5,
	time_shift_until_start_contest: getParsedQS().ts ? parseInt(getParsedQS().ts, 10) * ONE_MIN : 15 * ONE_MIN,

	up_show_live_start: 15 * ONE_MIN,
	up_show_pre_game_start: 30 * ONE_MIN,
};

const randContest = {
	"id": 999999,
	"status": "scheduled",
	"region": "east",
	"name": "",
	"start_date_time": "2020-09-01T13:26:00-04:00",
	"number_rounds": 3,
	"is_herd": false
};

const randRound = {
	"id": 999999,
	"position": 1,
	"is_sponsored": true,
	"status": "complete",
	"name": "just_trivia",
	"category": "All",
	"tag_line": "Kings and Queens of meaningless facts, this round's for you.",
	"type": "rapid_fire_2",
	"time_to_answer": 10,
	"start_date_time": "2020-09-01T13:26:00-04:00",
	"number_questions": 4,
	"points_per_question": 100,
	"questions": []
};

const randQuestion = {
	"id": 999999,
	"position": 2,
	"status": "scheduled",
	"title": "What is the name of the Atlanta Falcons mascot?",
	"answer_type": EnumTriviaAnswerType.multiple_choice,
	"end_date_time": "2020-07-31T14:27:10-04:00",
	"time_to_results": 5,
	"time_to_fan_fact": 0,
	"time_to_bubbles_message": 10,
	"round_id": 999999,
	is_practice: true,
	"answer_choices": [
		{
			"id": 218,
			"title": "Fabian",
			"value": 0,
			"percents": 0
		},
		{
			"id": 217,
			"title": "Freddie",
			"value": 0,
			"percents": 0
		},
		{
			"id": 219,
			"title": "Frank",
			"value": 0,
			"percents": 0
		},
		{
			"id": 220,
			"title": "Birdperson",
			"value": 0,
			"percents": 0
		}
	]
};

export const teaserQuestion = {
	randContest,
	randRound,
	randQuestion
};

export type IRoundLogos = keyof typeof roundLogos;

export const roundLogos = {
	warm_ups,
	icymi,
	just_trivia,
	all_type_no_hype,
	'50_50': fifty_fifty,
	light_sky,
	dos_equis,
	true_or_fail,
	heineken,
	campari_wild_turkey_longbranch,
	longbranch: campari_wild_turkey_longbranch,
	michelob_ultra,
	dulce_vida_milestone: michelob_ultra,
	michelob_ultra_dulce_vida: michelob_ultra,
	movie_buff,
	heart_the_90s,
	remember_books,
	geography_ugh,
	munchies,
	body_shots,
	omg,
	balls_and_bats,
	in_telly_gent,
	mother_earth,
	what_the_tech,
	real_news,
	history_lesson,
	smarty_pants,
	business_casual,
	console_me,
	noted,
	blazin_round,
	two_rights_and_wrong,
	swipe_it,
	take_5,
	finals,
	goat
} as const;

export const BWW_WEB_STORE_ID = Number(getParsedQS().BWW_store_id);

interface IContestTypeTitle {
	title?: string;
	short_title?: string;
}

const ContestTypeTitle: Record<EnumTriviaContestType, IContestTypeTitle> = {
	[ EnumTriviaContestType.lunchtime ]: {
		title: 'Lunchtime Trivia',
		short_title: 'Lunchtime'
	},
	[ EnumTriviaContestType.happy_hour ]: {
		title: 'Happy Hour Trivia',
		short_title: 'Happy Hour'
	},
	[ EnumTriviaContestType.late_night ]: {
		title: 'Late Night Trivia',
		short_title: 'Late Night'
	},
	[ EnumTriviaContestType.team_night ]: {
		title: 'Blazin\' Trivia',
		short_title: 'Blazin\''
	}
};

export const getContestTypeTitle = (type: EnumTriviaContestType | undefined) => {
	if ( !type ) {
		return {
			title: '',
			short_title: ''
		};
	}

	return ContestTypeTitle[ type ];
};

export const showWarningScreen = (question: ITriviaQuestion) => {
	if ( question.is_practice ) {
		return false;
	}

	if ( question.status === EnumTriviaStatusType.complete ) {
		return false
	}

	if ( question ) {
		const now = new Date().getTime();
		const question_start = new Date(String(question.start_date_time)).getTime();
		return question_start - now > ONE_SEC;
	}

	return true;
};

interface ITriviaAnalyticsGA {
	trivia: {
		type: string,
		name: string,
		total_rounds: number,
		current_round: number,
		current_round_name: string
	}
}

interface IRoundStart extends ITriviaAnalyticsGA {
	event: 'trivia_round_start'
}

interface IRoundEnd extends ITriviaAnalyticsGA {
	event: 'trivia_round_end',
	user_score: string // (2/3) 2 - correct / 3 - total questions
}

interface IQuestionAnswered extends ITriviaAnalyticsGA {
	event: 'trivia_question_answered'
	question: string,
	question_index?: number,
	user_answer: string
	correct_answer: string
}

export const TRIVIA_ANALYTICS = {
	send: (options: IRoundStart | IRoundEnd | IQuestionAnswered) => {
		TagManager.dataLayer({
			dataLayer: options
		})
	},
};

export const timerLeftClass = (value: number) => {
	if ( value <= 3000 ) {
		return ' err';
	} else if ( value <= 7000 ) {
		return ' warn';
	} else {
		return '';
	}
};

interface IRapidPoints {
	points_per_question: number;
	time_to_answer: number;
	answered_time: number;
}

export const getRapidPoints = ({points_per_question, time_to_answer, answered_time}: IRapidPoints) => {
	const points = Math.round(points_per_question / time_to_answer * answered_time);
	return points > points_per_question ? points_per_question : points;
};

export const prepareQuestionsToStore = (questions: ITriviaQuestion[], round_id: number) => {
	return map(questions, (question: ITriviaQuestion) => {
		return {
			...question,
			round_id
		}
	})
}

export const getTimeToComplete = (end_date_time: string | Date, debug: boolean = false) => {

	if ( +new Date(end_date_time) < +new Date() && debug ) {
		return 60
	}
	return ( +new Date(end_date_time) - +new Date() ) / ONE_SEC
}


export const getBonusPoints = (time: number) => {
	if ( time <= 10 ) {
		return 25;
	}

	if ( time <= 30 ) {
		return 10
	}
	return 0;
}


export const setDebugTimes = (contest: ITriviaContest): ITriviaContest => {
	const delta = +new Date() + TIMINGS.time_shift_until_start_contest - +new Date(contest.start_date_time);

	if ( contest.status === EnumTriviaContestStatus.voided ) {
		throw new Error(`contest ${contest.id} was voided`)
	}

	const changeTimeISO = (data: string | Date | undefined) => {
		return toISO(+new Date(data || '') + delta)
	};

	const changeTime = (data: string | Date | undefined) => {
		return new Date(+new Date(data || '') + delta)
	};

	const newRounds = map(contest.rounds, round => {
		return {
			...round,
			start_date_time: changeTimeISO(round.start_date_time),
			status: EnumTriviaStatusType.scheduled,
			questions: map(round.questions, (question) => {
				return {
					...question,
					status: EnumTriviaStatusType.scheduled,
					start_date_time: changeTime(question.start_date_time),
					end_date_time: changeTime(question.end_date_time),
				}
			})
		}
	})

	return {
		...contest,
		rounds: newRounds,
		status: EnumTriviaContestStatus.scheduled,
		start_date_time: changeTimeISO(contest.start_date_time),
		end_date_time: changeTimeISO(contest.end_date_time)
	};
}

export const convertToCorrectAnswer = (choice: IAnswerChoice): ITriviaCorrectAnswer => {
	return {
		question_id: 0,
		value: '',
		percents: 0,
		variants: [],
		...choice,
	}
}

const pluralize = (value: number, str: string) => {
	if(!value) {
		return '';
	}

	return value > 1 ? `${str}s` : str;
}

const singleDigits = ["Zero", "One", "Two",   "Three", "Four",
	"Five", "Six", "Seven", "Eight", "Nine"];

export const buildHintForTriviaFreeResponse = (wordsMapLength: number[]) => {
	const letters = wordsMapLength.map(count => `${count} ${pluralize(count, 'letter')}`).join(', ');
	return `${singleDigits[wordsMapLength.length]} ${pluralize(wordsMapLength.length,'word')} - ${letters}`
}